export default "__VITE_ASSET__DuixQjFo__"